import * as types from "../mutation-types";
import {resetStoreState} from "@/store/storeUtils";

const defaultState = {
    receivableFilterData: {
        // debtor
        debtorName: '',
        debtorCreditsafeRating: '',
        debtorCreditsafeRatingFrom: '',
        debtorCreditsafeRatingTo: '',
        debtorIndustry: [],
        debtorCountry: [],
        debtorPostCode: '',
        debtorCity: '',
        debtorLegalStructureId: null,

        // seller
        buyerName: '',
        buyerIndustry: [],
        buyerCountry: [],
        buyerPostCode: '',
        buyerCity: '',
        buyerLegalStructureId: null,

        // details
        receivableType: [],
        currency: '',
        amount: '',
        amountFrom: '',
        amountTo: '',
        dueDate: '',
        applicableLaw: [],

        // Empirical analysis and current ROI
        outStanding: '',
        calculatedLpd: '',
        outStandingFrom: '',
        outStandingTo: '',
        calculatedLpdFrom: '',
        calculatedLpdTo: '',
    },

    // 手动添加from to 分离的值
    customFromToValKeys: ['amount', 'outStanding', 'calculatedLpd', 'dueDate'],

    // 过滤数据类型
    receivableDataTypes: {
        // debtor
        debtorName: {
            fieldType: 'S',
            matchType: 'LIKE'
        },
        // form to
        debtorCreditsafeRating: {
            fieldType: 'S',
            matchType: "LIKE"
        },
        debtorIndustry: {
            fieldType: 'L',
            matchType: "IN"
        },
        debtorCountry: {
            fieldType: 'S',
            matchType: "IN"
        },
        debtorPostCode: {
            fieldType: 'S',
            matchType: "LIKE"
        },
        debtorCity: {
            fieldType: 'S',
            matchType: 'LIKE'
        },
        debtorLegalStructureId: {
            fieldType: 'L',
            matchType: 'IN'
        },

        // seller
        buyerName: {
            fieldType: 'S',
            matchType: 'LIKE'
        },
        buyerIndustry: {
            fieldType: 'L',
            matchType: 'IN'
        },
        buyerCountry: {
            fieldType: 'S',
            matchType: 'IN'
        },
        buyerPostCode: {
            fieldType: 'S',
            matchType: 'LIKE'
        },
        buyerCity: {
            fieldType: 'S',
            matchType: 'LIKE'
        },
        buyerLegalStructureId: {
            fieldType: 'L',
            matchType: 'IN'
        },

        // details
        receivableType: {
            fieldType: 'S',
            matchType: 'LIKE'
        },
        currency: {
            fieldType: 'S',
            matchType: 'LIKE'
        },
        dueDate: {
            fieldType: 'D',
            matchType: null
        },
        amount: {
            fieldType: 'C',
            matchType: null
        },
        applicableLaw: {
            fieldType: 'S',
            matchType: "IN"
        },

        // Empirical analysis and current ROI
        outStanding: {
            fieldType: 'C',
            matchType: null
        }
    }
};

const state = {
    ...defaultState
};

const setColumnFilterData = (columnName, fieldType, matchType, value) => ({
    columnName,
    fieldType,
    matchType,
    value
});

const getters = {
    receivableFilterData(state) {
        return state.receivableFilterData;
    },
    applyedReceivableFilterData(state) {
        const filterData = state.receivableFilterData;
        const types = state.receivableDataTypes;
        const applyFilterData = [];

        Object.keys(types).forEach(key => {
            if (state.customFromToValKeys.includes(key)) {
                let fromVal = filterData[key + 'From'];
                let toVal = filterData[key + 'To'];
                if (key == 'dueDate') {
                    fromVal = filterData[key][0]
                } else {
                    toVal = filterData[key][1]
                }

                if (fromVal) {
                    applyFilterData.push(
                        setColumnFilterData(key, types[key].fieldType, 'GE', fromVal)
                    );
                }
                if (toVal) {
                    applyFilterData.push(
                        setColumnFilterData(key, types[key].fieldType, 'LE', toVal)
                    );
                }
            } else if (filterData[key]) {
                let value = filterData[key]
                if (types[key].matchType == 'IN' && Array.isArray(filterData[key])) {
                    value = filterData[key].join(',')
                }
                if (value && value.length > 0) {
                    applyFilterData.push(
                        setColumnFilterData(key, types[key].fieldType, types[key].matchType, value)
                    );
                }

            }
        });
        return applyFilterData;
    }
}
const actions = {
    setActionFilterVal({
        commit
    }, payload) {
        commit(types.SET_RECEIVABLES_FILTER, payload);
    }
}
const mutations = {
    [types.SET_RECEIVABLES_FILTER](state, {
        key,
        value
    }) {
        state.receivableFilterData[key] = value;
    },
    initReceivablesState(state) {
        resetStoreState(state, defaultState);
    }
}



export default {
    state,
    getters,
    actions,
    mutations
}